export default {
    AE: 'UAE',
    BO: 'Bolivien',
    CD: 'Kongo',
    CF: 'Zentralafrikanische Republik',
    FK: 'Falkland Inseln',
    FM: 'Mikronesien',
    GB: 'Vereinigtes Königreich',
    GS: 'SGSSI',
    IO: 'BIOT',
    IR: 'Iran',
    KP: 'Nord Korea',
    KR: 'Südkorea',
    LA: 'Laos',
    MD: 'Moldawien',
    MF: 'Sankt Martin',
    PS: 'Palästina',
    RU: 'Russland',
    SX: 'Sint Maarten',
    TW: 'Taiwan',
    TZ: 'Tansania',
    US: 'USA',
    VE: 'Venezuela',
    VG: 'Virgin Inseln (Britisch)',
    VI: 'Virgin Islands (US)',
};
